<template>
  <v-container fluid grid-list-md>
    <v-layout class="mt-5" v-if="isLoading" align-center justify-center column fill-height>
      <v-progress-circular size="70" width="7" color="purple" indeterminate></v-progress-circular>
      <div>Loading...</div>
    </v-layout>
    <div v-if="!isLoading">
      <v-layout column fill-height>
        <v-flex>
          <v-card class="border-r-0">
            <v-toolbar class="elevation-0" color="gray">
              <v-toolbar-title>
                <h1 class="subheading">{{ $t("pageHeader.editInvoice") }}</h1>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="info" :disabled="saveBtnStatus" @click="update">Update</v-btn>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex d-flex xs12 sm4>
                  <v-card class="elevation-0" fill-height color="grey lighten-4">
                    <v-toolbar class="elevation-0" height="45" color="grey lighten-2">
                      <v-toolbar-title>
                        <h1 class="subheading">{{ $t("pageHeader.billing") }}</h1>
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      <v-layout column>
                        <v-flex xs12>
                          <h2 class="title font-weight-regular">
                            {{ location.CSPID }} - {{ location.businessName }}
                          </h2>
                        </v-flex>
                        <v-flex xs12>
                          <div>{{ location.address }}</div>
                        </v-flex>
                        <v-flex xs12
                          ><span
                            >{{ location.city }}, {{ location.State.stateSymbol }}
                            {{ location.zipcode }}</span
                          ></v-flex
                        >
                        <v-flex xs12>
                          <div>{{ location.businessPhone }}</div>
                        </v-flex>
                        <v-flex xs12>
                          <div>{{ location.businessEmail }}</div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex d-flex xs12 sm4>
                  <v-card class="elevation-0" color="grey lighten-4">
                    <v-toolbar class="elevation-0" height="45" color="grey lighten-2">
                      <v-toolbar-title>
                        <h1 class="subheading">{{ $t("pageHeader.shipping") }}</h1>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <toggle-button
                        class="ml-3"
                        v-model="sameAsBilling"
                        @change="shppingAddress"
                        :labels="{ checked: 'Same as billing', unchecked: 'Different' }"
                        :width="110"
                        :sync="true"
                      ></toggle-button>
                    </v-toolbar>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12 sm6="sm6">
                          <v-text-field v-model="invoice.shipName" label="Name"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6="sm6">
                          <v-text-field
                            v-model="invoice.shipBusinessName"
                            label="Business Name"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="invoice.shipAddress"
                            label="Address"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6="sm6">
                          <v-text-field v-model="invoice.shipCity" label="City"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm2>
                          <v-text-field v-model="invoice.shipState" label="State"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            v-model="invoice.shipZipcode"
                            label="Zipcode"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex d-flex xs12 sm4>
                  <v-card class="elevation-0" color="grey lighten-4">
                    <v-toolbar class="elevation-0" height="45" color="grey lighten-2">
                      <v-toolbar-title>
                        <h1 class="subheading">{{ $t("labels.date") }}</h1>
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <DateTimePicker
                            :showIcon="false"
                            :range="false"
                            :clearable="false"
                            :hideTime="true"
                            label="Invoice Date"
                            v-on:input="setInvoiceDate"
                            :initStartDate="$moment(invoice.createDateTime)"
                            :noFuture="true"
                          ></DateTimePicker>
                        </v-flex>
                        <v-flex xs6>
                          <DateTimePicker
                            :showIcon="false"
                            :range="false"
                            :clearable="false"
                            :hideTime="true"
                            label="Charge Date"
                            v-on:input="setChargeDate"
                            :initStartDate="$moment(invoice.chargeDateTime)"
                            :noFuture="true"
                          ></DateTimePicker>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="invoice.shipBy"
                            label="Shipping Carrier"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="invoice.trackingNumber"
                            label="Tracking Number"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex>
          <v-card>
            <v-card-text>
              <v-layout align-center justify-space-between row fill-height wrap>
                <v-flex xs12 sm3>
                  <v-autocomplete
                    autofocus="autofocus"
                    clearable="clearable"
                    item-text="productDetail"
                    @input="input"
                    v-model="selectedProduct"
                    :items="products"
                    return-object
                    :label="$t('labels.searchProduct')"
                  >
                    <template slot="item" slot-scope="{ item }">
                      <span>{{ item.productDetail }}</span>
                      <v-spacer></v-spacer>
                      <v-chip v-if="item.trackInventory" dark color="info">
                        <span>{{ item.stock }}</span>
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field v-model="invoiceBar.name" label="Item Name"></v-text-field>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-text-field
                    class="centered-input"
                    v-model="invoiceBar.quantity"
                    label="Quantity"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-text-field class="right-input" v-model="invoiceBar.rate" label="Unit Price">
                  </v-text-field>
                </v-flex>
                <v-flex d-flex xs12 sm1>
                  <v-btn color="info" large @click="addToCart" :disabled="!selectedProduct">
                    add
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card>
                <v-card-text>
                  <v-data-table
                    class="elevation-0"
                    :headers="headers"
                    hide-actions="hide-actions"
                    :items="invoice.invoiceDetails"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>
                          <v-layout align-center justify-start row fill-height wrap>
                            <v-btn icon="icon" @click="deleteItem(props.item)">
                              <v-icon color="red">delete</v-icon>
                            </v-btn>
                            <span>{{ props.item.productDetail }}</span>
                            <span class="ml-3" v-if="props.item.productType === 'Renew'">
                              <v-text-field label="Given Days" v-model="props.item.givenDay">
                              </v-text-field>
                            </span>
                            <span class="ml-3" v-if="props.item.productType === 'Hardware'">
                              <AttachSerial v-model="props.item" />
                            </span>
                          </v-layout>
                        </td>
                        <td>{{ props.item.qty }}</td>
                        <td>
                          <v-layout align-center justify-start row fill-height wrap
                            ><span>{{ props.item.taxAmount | currency }}</span
                            ><toggle-button
                              class="ml-3"
                              @change="applyTax(props.item)"
                              v-model="props.item.isTax"
                              :labels="true"
                              :sync="true"
                            >
                            </toggle-button
                          ></v-layout>
                        </td>
                        <td>{{ props.item.rate | currency }}</td>
                        <td>{{ props.item.total | currency }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex>
          <v-layout align-start justify-space-between row wrap>
            <v-flex d-flex xs12 sm3>
              <v-card>
                <v-card-text>
                  <v-layout column wrap>
                    <v-flex xs12>
                      <v-layout row
                        ><span class="mr-1">{{ $t("labels.totalGivingDays") }}:</span>
                        <v-spacer></v-spacer
                        ><span class="font-weight-medium">{{ totalGivingDays }}</span></v-layout
                      >
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex d-flex xs12 sm3 order-xs1>
              <v-card>
                <v-card-text>
                  <v-layout column wrap>
                    <v-flex xs12>
                      <v-layout row
                        ><span class="mr-1">{{ $t("labels.subtotal") }}:</span> <v-spacer></v-spacer
                        ><span class="font-weight-medium">{{ subTotal | currency }}</span></v-layout
                      >
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row
                        ><span class="mr-1">{{ $t("labels.taxAmount") }}:</span>
                        <v-spacer></v-spacer
                        ><span class="font-weight-medium">{{
                          taxTotalAmount | currency
                        }}</span></v-layout
                      >
                    </v-flex>
                    <v-divider class="mt-2 mb-2"></v-divider>
                    <v-flex xs12>
                      <v-layout row
                        ><span class="mr-1">{{ $t("labels.dueAmount") }}:</span>
                        <v-spacer></v-spacer
                        ><span class="font-weight-medium">{{
                          grandTotal | currency
                        }}</span></v-layout
                      >
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import DateTimePicker from '../../Global/components/DateTimePicker';
import invoiceService from '../service.js';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import AttachSerial from './AttachSerial';
import locationService from '../../Location/service.js';

export default {
  name: 'edit-invoice',
  data() {
    return {
      location: null,
      invoiceID: null,
      invoiceMenu: false,
      chargeManu: false,
      saveBtnLoading: false,
      sameAsBilling: false,
      isLoading: true,
      selectedProduct: null,
      invoiceBar: {
        product: null,
        name: null,
        quantity: 1,
        rate: 0,
        total: 0,
      },
      dialog: false,
      stores: [],
      products: [],
      headers: [
        {
          text: this.$t('labels.itemName'),
          align: 'left',
          value: 'test',
          sortable: false,
        },
        {
          text: this.$t('labels.quantity'),
          value: 'businessName',
          sortable: false,
        },
        {
          text: this.$t('labels.tax'),
          value: 'address',
          sortable: false,
        },
        {
          text: this.$t('labels.unitPrice'),
          value: 'showInTransferOnly',
          sortable: false,
        },
        {
          text: this.$t('labels.total'),
          value: 'showInTransferOnly',
          sortable: false,
        },
      ],
      invoice: null,
    };
  },
  components: {
    DateTimePicker,
    VueCtkDateTimePicker,
    AttachSerial,
  },
  computed: {
    ...mapGetters('global', ['currentUser']),
    invoiceDateFormatted() {
      return this.$moment(this.invoice.createDateTime).format('MM/DD/YYYY');
    },
    chargeDateFormatted() {
      return this.$moment(this.invoice.chargeDateTime).format('MM/DD/YYYY');
    },
    saveBtnStatus() {
      if (this.invoice.invoiceDetails.length === 0) {
        return true;
      }
      return false;
    },
    // newDueDate() {
    //   return this.$moment(this.location.dueDate).add(this.totalGivingDays, 'days').utc().calendar()
    // },
    totalGivingDays() {
      let total = 0;
      this.invoice.invoiceDetails.map(row => {
        total = total + row.givenDay;
      });
      return total;
    },
    subTotal() {
      let total = 0;
      this.invoice.invoiceDetails.map(row => {
        total = parseFloat(total) + parseFloat(row.total);
      });
      return total;
    },
    taxTotalAmount() {
      let total = 0;
      this.invoice.invoiceDetails.map(row => {
        total = parseFloat(total) + parseFloat(row.taxAmount);
      });
      return total;
    },
    grandTotal() {
      return parseFloat(this.subTotal) + parseFloat(this.taxTotalAmount);
    },
  },
  async created() {
    if (!this.$route.params || !this.$route.params.id) return this.$router.push('/user/list');
    const id = this.$route.params.id;

    await this.getInvoiceProduct();
    await this.getInvoice(id);
  },
  methods: {
    getLocation(storeID) {
      return locationService.getbyId(storeID).then(result => {
        this.location = result;
        console.log('location', this.location);
        this.isLoading = false;
        return true;
      });
    },
    setInvoiceDate(val) {
      this.invoice.createDateTime = val;
    },
    setChargeDate(val) {
      this.invoice.chargeDateTime = val;
    },
    saveCreateDateTime() {
      console.log('date', this.invoice.createDateTime);
      this.invoice.createDateTime = this.$moment(this.invoice.createDateTime);
      console.log('moment', this.invoice.createDateTime);
    },
    shppingAddress() {
      if (this.sameAsBilling) {
        this.invoice.shipName = this.location.businessName;
        this.invoice.shipBusinessName = this.location.businessName;
        this.invoice.shipAddress = this.location.address;
        this.invoice.shipCity = this.location.city;
        this.invoice.shipState = this.location.State.stateSymbol;
        this.invoice.shipZipcode = this.location.zipCode;
      } else {
        this.invoice.shipName = null;
        this.invoice.shipBusinessName = null;
        this.invoice.shipAddress = null;
        this.invoice.shipCity = null;
        this.invoice.shipState = null;
        this.invoice.shipZipcode = null;
      }
    },
    setInvoiceDate(val) {
      this.invoice.createDateTime = val;
    },
    setChargeDate(val) {
      this.invoice.chargeDateTime = val;
    },
    applyTax(item) {
      const invoiceIndex = this.invoice.invoiceDetails.indexOf(item);
      this.invoice.invoiceDetails.map((row, index) => {
        if (invoiceIndex === index) {
          if (row.isTax) {
            row.taxAmount = (row.total * this.location.State.taxCollect) / 100;
          } else {
            row.taxAmount = 0;
          }
        }
      });
    },
    addToCart() {
      if (this.selectedProduct) {
        if (this.selectedProduct.trackSerialNumber) this.invoiceBar.quantity = 1;
        var taxAmount = 0;
        var isTax = false;
        var showTaxCheckbox = false;
        this.invoiceBar.total = this.invoiceBar.rate * this.invoiceBar.quantity;
        if (this.invoiceBar.product.productType === 'Hardware') {
          if (this.location.State.taxCollect !== 0) {
            taxAmount = (this.invoiceBar.total * this.location.State.taxCollect) / 100;
            console.log(
              'selected product',
              this.location.State.taxCollect,
              this.invoiceBar.total,
              taxAmount,
              this.invoiceBar,
            );
            isTax = true;
            showTaxCheckbox = true;
          }
        }
        let data = {
          productID: this.invoiceBar.product.productID,
          productDetail: this.invoiceBar.name,
          qty: this.invoiceBar.quantity,
          rate: this.invoiceBar.rate,
          total: this.invoiceBar.quantity * this.invoiceBar.rate,
          productType: this.invoiceBar.product.productType,
          givenDay: this.invoiceBar.product.dayCycle,
          taxAmount: taxAmount,
          isTax: isTax,
          showTaxCheckbox: showTaxCheckbox,
          hardwareSerial: '',
        };
        this.invoice.invoiceDetails.push(data);
        this.resetInvoiceBar();
      }
    },
    resetInvoiceBar() {
      let resetInvoiceBar = {
        product: null,
        name: null,
        quantity: 1,
        rate: 0,
        total: 0,
      };
      this.invoiceBar = resetInvoiceBar;
      this.selectedProduct = null;
    },
    input(val) {
      if (val) {
        this.invoiceBar.product = val;
        this.invoiceBar.name = val.productDetail;
        this.invoiceBar.rate = val.amount;
        this.invoiceBar.total = this.invoiceBar.rate * this.invoiceBar.quantity;
      }
    },
    getInvoiceProduct() {
      return invoiceService.getInvoiceProduct().then(result => {
        console.log('product', result);
        this.products = result.data;
        return result;
      });
    },
    getInvoice(id) {
      return invoiceService.getInvoiceByID(id).then(async result => {
        console.log('getInvoiceByID', result);
        this.invoiceID = result.data.invoiceID;
        this.invoice = {
          createDateTime: result.data.createDateTime,
          taxAmount: result.data.taxAmount,
          taxRate: result.data.taxRate,
          invoiceAmount: result.data.invoiceAmount,
          chargeDateTime: result.data.chargeDateTime,
          paidDateTime: result.data.paidDateTime,
          storeID: result.data.storeID,
          trackingNumber: result.data.trackingNumber,
          shipBy: result.data.shipBy,
          givenDay: result.data.givenDay,
          shipName: result.data.shipName,
          shipBusinessName: result.data.shipBusinessName,
          shipAddress: result.data.shipAddress,
          shipCity: result.data.shipCity,
          shipState: result.data.shipState,
          shipZipcode: result.data.shipZipcode,
          invoiceDetails: [],
        };
        await this.getLocation(this.invoice.storeID);
        result.data.InvoiceDetails.map(row => {
          row.productType = row.Product.productType;
          row.showTaxCheckbox = false;
          if (row.Product.productType === 'HARDWARE') {
            if (this.location.State.taxCollect !== 0) {
              row.showTaxCheckbox = true;
            }
          }
          this.invoice.invoiceDetails.push(row);
        });
        return result;
        // this.invoice = result.data
      });
    },
    close() {
      this.$router.go(-1);
    },
    deleteItem(item) {
      const index = this.invoice.invoiceDetails.indexOf(item);
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          this.invoice.invoiceDetails.splice(index, 1);
          this.$Progress.finish();
        }
      });
      // confirm('Are you sure you want to delete this item?') && this.invoice.invoiceDetails.splice(index, 1)
    },
    update() {
      this.$Progress.start();
      this.saveBtnLoading = true;
      this.invoice.storeID = this.location.storeID;
      this.invoice.userID = this.currentUser.userID;
      this.invoice.invoiceAmount = this.subTotal;
      this.invoice.taxRate = this.location.State.taxCollect;
      this.invoice.taxAmount = this.taxTotalAmount;
      invoiceService
        .updateInvoice(this.invoiceID, this.invoice)
        .then(result => {
          this.saveBtnLoading = false;
          this.$swal
            .mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: 'success',
              title: 'Invoice was updated successfully',
            });
          this.$router.go(-1);
          // this.$router.push({ path: `/location/profile/${this.location.storeID}` });
        })
        .catch(err => {
          console.log('err', err);
          this.saveBtnLoading = false;
        });
      this.$Progress.finish();
    },
  },
};
</script>

<style scoped></style>
